<template>
  <v-app id="app_measurements">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">CREATE & VIEW MEASUREMENTS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Create a new Product measurement category for your
            needs.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-btn color="#05146F" size="x-large" variant="text" @click="MeasurementBulkUploadDialog = true">
              <v-icon>mdi-file-upload-outline</v-icon>&nbsp;&nbsp;DATA BULK UPLOAD
            </v-btn>
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="true" rounded="lg">
        <v-card-text class="custom_tool_bar_style d-flex align-center">
          <div class="d-flex align-center flex-grow-1">
            <p class="custom_page_component_main_title ma-0">PRODUCT MEASUREMENT LIST</p>
          </div>
          <div class="d-flex align-center">
            <v-btn class="custom_measurement_btn" variant="outlined" @click="openDialog" v-if="permissions.write">
              &nbsp;&nbsp;CREATE MEASUREMENTS
            </v-btn>
            <v-btn class="custom_pdf_btn ml-4" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
            <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </div>
        </v-card-text>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <!-- Number of measurement units -->
        <v-row align="center" justify="space-between">
          <!-- Left Side: Measurement Card -->
          <v-col cols="auto">
            <v-card elevation="1" class="pa-3 d-flex align-center">
              <div>
                <h1 class="custom_number_of_measurement_btn">{{ totalMeasurements }}</h1>
                <p class="font-weight-medium">NUMBER OF MEASUREMENT UNITS</p>
              </div>
            </v-card>
          </v-col>

          <!-- Right Side: Search Bar -->
          <v-col cols="12" md="4">
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" clearable hide-details
                          label="Search" placeholder="Search Products" variant="outlined"
                          class="custom_input_field_color" density="comfortable"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <v-data-table
            :headers="headers"
            :items="measurementUnits"
            :search="search"
            :items-per-page="itemsPerPage"
            class="elevation-1"
        >
          <!--          <template v-slot:[`item.description`]="{ item }">-->
          <!--            {{ stripHtmlTags(item.description) }}-->
          <!--          </template>-->
          <template v-slot:[`item.description`]="{ item }">
              <span v-if="item.description && item.description.length" v-html="getSanitizedHTML(item.description)">
              </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu transition="slide-x-transition" id="app_product_list">
              <template v-slot:activator="{ props }">
                <v-btn class="custom_btn_primary" variant="flat" size="large" v-bind="props">
                  ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="permissions.write" @click="editMeasurement(item)">
                  <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                  <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>

        <!--        <v-pagination-->
        <!--            v-model="page"-->
        <!--            :length="totalPages"-->
        <!--            @input="changePage"-->
        <!--            class="my-4"-->
        <!--        ></v-pagination>-->

      </v-card>
      <v-dialog v-model="dialog" max-height="700" id="app_lead_list" max-width="600">
        <v-card rounded="md" style="overflow:hidden !important;">
          <div class="pa-4">
            <!-- Dialog Title -->
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">{{ dialogTitle }}</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="closeDialog" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                    v-model="measurementName"
                    label="Measurement Name*"
                    placeholder="Create measurement name"
                    variant="outlined"
                    required
                    :rules="[rules.textOnly]"
                ></v-text-field>

                <v-text-field
                    v-model="unit"
                    label="Unit*"
                    placeholder="Create unit name"
                    variant="outlined"
                    required
                    :rules="[rules.textOnly]"
                    @input="updateUnitCount"
                >
                  <template v-slot:append-inner>
                    <span class="text-caption">{{ unitCount }}/20</span>
                  </template>
                </v-text-field>


                <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="lg" max-height="280" min-height="280">
                  <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                  <v-divider></v-divider>
                  <Editor aria-placeholder="Type Here..." v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode"
                          @onCreated="handleCreated" @onChange="handleEditorChange"/>

                </v-card>
                <v-card-text class="text-caption text-right">
                  Word Count: {{ charCount }}/300
                </v-card-text>

              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn color="primary" variant="flat" @click="saveMeasurement">{{ dialogButtonText }}</v-btn>
              <v-btn variant="outlined" @click="closeDialog">CANCEL</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="delete_measurement_dialog" max-height="500" max-width="500" persistent id="app_product_list">
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE MEASUREMENT</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="delete_measurement_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this measurement ?
                </v-card-title>

                <p v-if="using_count > 0" style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This measurement cannot be deleted because it is currently being used in {{ using_count }}
                  product{{ using_count > 1 ? 's' : '' }}.
                </p>

                <p v-else style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This measurement will be deleted immediately. Once deleted, it can no longer be used for any purpose.
                </p>

                <v-divider class="mt-4"></v-divider>

                <!-- Show associated products -->
                <div v-if="productList.length > 0">
                  <p class="font-weight-bold text-body-2 mb-2">Associated Products:</p>
                  <ul>
                    <li v-for="(product) in displayedProducts" :key="product.id">
                      <!--                      <strong>ID:</strong> {{ product.id }} - <strong>Title:</strong> {{ product.product_title }}-->
                      {{ product.product_title }} , product ID of {{ product.id }}.
                    </li>
                  </ul>
                  <p v-if="productList.length > 3" class="text-body-2 mt-3">...</p>
                </div>
                <!--                <p v-else class="text-body-2 text-grey">No associated products found.</p>-->

                <v-divider v-if="productList.length > 0" class="mt-4"></v-divider>


                <div class="float-end mt-4 ">
                  <v-btn class="custom_btn_primary" @click="deleteItems" :disabled="using_count > 0">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="delete_measurement_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
      <!-- Measurement Bulk Upload Dialog -->
      <v-dialog v-model="MeasurementBulkUploadDialog" fullscreen id="app_add_leads">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo_full_5.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="custom_red_btn" variant="flat" @click="MeasurementBulkUploadDialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15  custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPLOAD SPREADSHEET
                  </v-card-title>
                </template>
              </v-card>

              <v-card class="px-3 mx-6 mt-3 custom_card_box" elevation="1" border="sm opacity-1" rounded="lg">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="5" lg="5">
                    <p class="text-body-1 font-weight-medium  mb-4 mt-4">
                      Upload your measurement bulk data set using excel or a csv file.
                    </p>
                    <v-divider></v-divider>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <v-file-input accept=".csv, .xls, .xlsx"
                                    clearable density="comfortable"
                                    class="custom_input_field_color mt-3" label="Upload your Excel or CSV file *"
                                    counter show-size variant="outlined"
                                    @change="handleFileUpload"></v-file-input>
                    </v-col>
                  </v-col>

                  <v-col class="d-flex align-center justify-center" cols="1">
                    <v-divider :thickness="2" vertical></v-divider>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-card class="d-flex align-center justify-space-between pa-4 mt-3" color="#F0F0F0" flat
                                width="100%">
                          <card class="mr-4" border="lg">
                            <p class="mb-0 text-body-2 font-weight-bold">DOWNLOAD SAMPLE TEMPLATE</p>
                          </card>
                          <v-divider vertical></v-divider>
                          <v-btn class="custom_btn_primary" size="x-large" variant="text" @click="downloadTemplate">
                            DOWNLOAD
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-card v-if="bulkItems.length > 0" flat>
                  <v-card-text>
                    <v-divider class="mb-4 "></v-divider>
                    <v-data-table :headers="bulkHeaders" :items="bulkItems" :items-per-page="itemsPerPage"
                                  class="custom_table_normal">
                      <template v-slot:[`item.subCategory`]="{ item }">
                        <span class="red--text">{{ item.subCategory }}</span>
                      </template>
                      <template v-slot:[`item.assignAgent`]="{ item }">
                        <span>{{ item.assignAgent }}<br/><span class="red--text">{{ item.regNum }}</span></span>
                      </template>
                      <!-- Add the Action column with a drop icon -->
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon color="red" @click="removeItem(item)">mdi-delete</v-icon>
                      </template>
                    </v-data-table>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="float-end">
                    <v-btn :disabled="bulkItems.length === 0" class="custom_btn_primary  mt-2 mb-3" size="large"
                           variant="text" @click="uploadBulkMeasurement">Upload
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" location="top-right" outlined>
        {{ snackbarMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>


      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import {Editor, Toolbar} from "@wangeditor/editor-for-vue";
import {onBeforeUnmount, onMounted, ref, shallowRef} from "vue";
import axios from "axios";
import {getPermissions} from "@/plugins/permissions";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import DOMPurify from "dompurify";

export default {
  components: {
    Editor,
    Toolbar,
  },

  setup() {
    const editorRef = shallowRef()
    const valueHtml = ref('<p></p>')

    onMounted(() => {
      setTimeout(() => {
        valueHtml.value = '<p></p>'
      }, 1500)
    })

    const toolbarConfig = {toolbarKeys: ['bold', 'italic', 'underline', 'through']}
    const editorConfig = {placeholder: 'Type here...'}

    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor
    }

    return {
      editorRef,
      mode: 'simple',
      valueHtml,
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },
  name: 'MeasurementList',
  data() {
    return {
      productList: [],
      rules: {
        textOnly: v => /^[A-Za-z\s]+$/.test(v) || "Only text is allowed",
      },
      charCount: 0,
      unitCount: 0,
      charLimit: 300,
      permissions: {},
      search: "",
      page: 1,
      itemsPerPage: 10,
      dialog: false,
      dialogTitle: 'CREATE MEASUREMENTS',
      dialogButtonText: 'CREATE',
      measurementName: '',
      selectedProductId: null,
      unit: '',
      description: '',
      measurementUnits: [],
      delete_measurement_dialog: false,
      MeasurementBulkUploadDialog: false,
      bulkFile: null,
      bulkItems: [],
      bulkHeaders: [
        {text: 'Measurement Name', value: 'Measurement Name', title: 'Measurement Name'},
        {text: 'Unit', value: 'Unit', title: 'Unit'},
        {text: 'Description', value: 'Description', title: 'Description'},
        {text: 'Actions', value: 'actions', title: 'Actions', sortable: false} // Add the Actions column
      ],
      bulkHeadersTwo: [
        {text: 'Measurement Name', value: 'Measurement Name', title: 'Measurement Name'},
        {text: 'Unit', value: 'Unit', title: 'Unit'},
        {text: 'Description', value: 'Description', title: 'Description'},
      ],
      headers: [
        {text: "MEASUREMENT NAME", value: "name", title: 'MEASUREMENT NAME', sortable: true},
        {text: "UNIT", value: "unit", title: 'UNIT', sortable: true},
        {text: "DESCRIPTION", value: "description", title: 'DESCRIPTION', sortable: true},
        {text: "ACTIONS", value: "actions", title: 'ACTIONS', sortable: true}
      ],
      editingMeasurement: null,
      snackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      centerLoading: false,
      snackAlert: {
        snackbar: false, // Snackbar visibility
        snackColor: "", // Snackbar color
        snackMessage: "", // Snackbar message
        snackBarRight: false, // Snackbar position right
        snackBarTop: true,  // Snackbar position top
      },
    };
  },
  computed: {
    displayedProducts() {
      return this.productList.slice(0, 3); // Show only first 3 products
    },
    totalMeasurements() {
      const count = this.measurementUnits.length;
      // Add leading zero if the count is below 10
      return count < 10 ? `0${count}` : count.toString();
    },
    totalPages() {
      return Math.ceil(this.measurementUnits.length / this.itemsPerPage);
    }
  },
  methods: {

    // Calculate character count
    calculateCharCount(html) {
      if (!html) return 0;
      const text = html.replace(/<[^>]+>/g, ''); // Remove HTML tags
      return text.length; // Count characters
    },

    // Handle editor content change
    handleEditorChange() {
      const text = this.valueHtml.replace(/<[^>]+>/g, ''); // Remove HTML tags
      if (text.length > this.charLimit) {
        this.showSnackbar(`Maximum limit of ${this.charLimit} characters reached.`, 'error');
        // this.valueHtml = text.substring(0, this.charLimit); // Truncate input
      }
      this.charCount = this.calculateCharCount(this.valueHtml);
    },

    updateUnitCount() {
      this.unitCount = this.unit.length;
      if (this.unitCount > 20) {
        this.showSnackbar(`Maximum limit of 20 characters reached.`, 'error');
        // this.valueHtml = text.substring(0, this.charLimit); // Truncate input
      }
    },

    async saveMeasurement() {
      // Validate character count
      if (this.charCount > this.charLimit) {
        this.showSnackbar(`Description must be ${this.charLimit} characters or less.`, 'error');
        return;
      }

      if (this.unit.length > 20) {
        this.showSnackbar('Unit must be 20 words or less.', 'error');
        return;
      }

      if (!this.measurementName || !this.unit) {
        this.showSnackbar('Measurement Name and Unit are required!', 'error');
        return;
      }
      const textOnlyRegex = /^[A-Za-z\s]+$/;
      if (!textOnlyRegex.test(this.measurementName) || !textOnlyRegex.test(this.unit)) {
        this.showSnackbar('Only letters and spaces are allowed for Measurement Name and Unit!', 'error');
        return;
      }

      const measurement = {
        name: this.measurementName,
        unit: this.unit,
        description: this.valueHtml,
      };

      const token = localStorage.getItem('token');

      if (this.editingMeasurement) {
        try {
          const response = await axios.post(
              `/api/update/measurements/${this.editingMeasurement.id}`,
              measurement,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              }
          );

          if (response.status === 200) {
            this.showSnackbar('Measurement successfully updated.', 'success');
            const index = this.measurementUnits.findIndex(m => m.id === this.editingMeasurement.id);
            this.measurementUnits.splice(index, 1, response.data);
            this.closeDialog();
          } else {
            this.showSnackbar('Failed to update measurement.', 'error');
          }
        } catch (error) {
          console.error('Error updating measurement:', error);
          this.showSnackbar('Failed to update measurement.', 'error');
        }
      } else {
        try {
          const response = await axios.post(
              '/api/create/measurements',
              measurement,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              }
          );

          this.measurementUnits.push(response.data);
          this.showSnackbar('Measurement successfully created.', 'success');
          this.closeDialog();
        } catch (error) {
          console.error('Error creating measurement:', error);

          // Check if the error has a response from the backend
          if (error.response) {
            const {status, data} = error.response;

            // Handle validation errors (status code 422)
            if (status === 422 && data.error) {
              const errorMessages = Object.values(data.error).flat().join(' ');
              this.showSnackbar(`Validation Error: ${errorMessages}`, 'error');
            }
            // Handle other backend errors
            else if (data.error) {
              this.showSnackbar(`Error: ${data.error}`, 'error');
            } else {
              this.showSnackbar('An unexpected error occurred.', 'error');
            }
          }
          // Handle network or other Axios errors
          else if (error.request) {
            this.showSnackbar('Network error. Please check your connection.', 'error');
          } else {
            this.showSnackbar('An unexpected error occurred.', 'error');
          }
        }
      }
    },


    removeItem(item) {
      console.log("item is", item);
      this.bulkItems = this.bulkItems.filter(i => i !== item); // Remove the item from the list
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    async uploadBulkMeasurement() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      // Validate file selection
      if (!this.bulkFile) {
        this.showSnackbar('No file selected for upload', 'error');
        console.error('No file selected for upload');
        return;
      }

      console.log("this.bulkFile", this.bulkItems);

      const formData = new FormData();
      formData.append('bulkItems', JSON.stringify(this.bulkItems)); // If it's an array or object
      formData.append('userId', userId);

      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }


      this.isLoading = true; // Show loading state
      this.showSnackbar('Uploading file, please wait...', 'info');  // Show upload notification

      try {
        const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/measurements/bulk-upload`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        );

        // Handle success
        console.log('Bulk upload response:', response.data);
        this.showSnackbar('Bulk upload successful', 'success');
        window.location.href = "/measurement-list";
      } catch (error) {
        // Enhanced error handling
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data.error || 'An error occurred.';
          console.error(`Error ${status}: ${message}`);

          switch (status) {
            case 400:
              this.showSnackbar(`Validation Error: ${message}`, 'error');
              break;
            case 401:
              this.showSnackbar('Unauthorized. Please log in again.', 'error');
              this.$router.push('/login');
              break;
            case 404:
              this.showSnackbar('User or resource not found.', 'error');
              break;
            case 500:
              this.showSnackbar('Server error. Please try again later.', 'error');
              break;
            default:
              this.showSnackbar(`Error: ${message}`, 'error');
          }
        } else if (error.request) {
          console.error('No response received:', error.request);
          this.showSnackbar('No response from the server. Please try again.', 'error');
        } else {
          console.error('Error setting up request:', error.message);
          this.showSnackbar('An unexpected error occurred. Please try again.', 'error');
        }
      } finally {
        this.isLoading = false; // Hide loading state
      }
    },


    handleFileUpload(event) {
      const file = event.target.files[0];
      this.bulkFile = file;
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {type: 'array'});

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1});
        const headers = jsonData[0].map(header => header ? header.toString().trim() : '');

        const expectedHeaders = this.bulkHeadersTwo.map(header => header.text);

        const headersMatch = headers.length === expectedHeaders.length &&
            headers.every((header, index) => header === expectedHeaders[index]);
        console.log('Headers:', headers, 'Expected:', expectedHeaders);

        if (!headersMatch) {
          this.snackbar = true;
          this.snackbarMessage = 'UPLOADED FILE WAS WRONG';
          this.snackbarColor = 'error';
          return;
        }

        const isSerialDate = value => !isNaN(value) && value > 0 && value < 2958465; // Excel date range
        const excelDateToJsDate = serial => {
          const jsDate = new Date(Date.UTC(1900, 0, serial - 1)); // Subtract 1 for Excel's 1900 leap year bug
          return jsDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        };

        const dataRows = jsonData.slice(1).map(row => {
          return headers.reduce((obj, header, index) => {
            let value = row[index];
            if (header === 'Assign Date' && isSerialDate(value)) {
              value = excelDateToJsDate(parseFloat(value));
            }
            obj[header] = value !== undefined && value !== null ? value.toString().trim() : '';
            return obj;
          }, {});
        });

        this.bulkItems = dataRows;
      };

      reader.readAsArrayBuffer(file);
    },

    async downloadTemplate() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const url = `${process.env.VUE_APP_API_BASE_URL}/api/measurements/download-template?userId=${userId}`;


      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        });

        if (!response.ok) {
          throw new Error('Failed to download template');
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'template_measurement_data.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.showSnackbar("Template download successfully!", "success");
      } catch (error) {
        console.error('Error downloading template:', error);
      }
    },
    // confirmDelete(item) {
    //   console.log('Deleting item:', item.id);
    //   this.selectedProductId = item.id;
    //   this.delete_measurement_dialog = true;
    // },


    async confirmDelete(item) {
      console.log('Deleting item:', item.id);
      this.selectedProductId = item.id;
      this.delete_measurement_dialog = true;

      try {
        const token = localStorage.getItem('token');

        const response = await axios.post(
            `/api/checkMeasurementAssociations/${this.selectedProductId}`,
            {},
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              }
            }
        );

        if (response.data.message === "No associated products found for this measurement.") {
          this.productList = []; // Clear sales lead list
          this.using_count = 0;   // Reset visited count
        }

        if (response.data.associated_data) {
          const associatedData = response.data.associated_data;

          // Ensure we correctly extract productList from the response
          this.productList = Array.isArray(associatedData.products) ? associatedData.products : [];
          this.using_count = associatedData.using_count || 0;

          // Adjust warning message based on usage
          this.deleteWarningMessage = this.using_count > 0
              ? "This measurement cannot be deleted."
              : "Do you want to delete this measurement?";

          console.log("Updated Product List:", this.productList); // Debugging log
        }

        this.delete_measurement_dialog = true;
      } catch (error) {
        console.error("Error fetching measurement associations:", error);
      }
    },
    getSanitizedHTML(html) {
      return DOMPurify.sanitize(html);
    },
    stripHtmlTags(html) {
      // Create a temporary div element
      const tempDiv = document.createElement("div");
      // Set the HTML content to the input
      tempDiv.innerHTML = html;
      // Return the text content without HTML tags
      return tempDiv.textContent || tempDiv.innerText || "";
    },

    fetchMeasurements() {
      const token = localStorage.getItem("token");
      console.log("token is ", token);

      axios.post(
          "/api/get/measurements",
          {}, // Request body (empty in this case)
          {
            headers: {
              'Authorization': `Bearer ${token}` // Ensure the token is prefixed with 'Bearer'
            }
          }
      )
          .then(response => {
            const data = response.data; // Axios automatically parses the JSON response
            this.measurementUnits = data.slice(0); // Fetch all measurements
            // Alternatively, no slice at all:
            // this.measurementUnits = data;
          })
          .catch(error => {
            console.error("Error fetching measurements:", error);
          });
    },
    openDialog() {
      this.dialogTitle = 'CREATE MEASUREMENTS';
      this.dialogButtonText = 'CREATE';
      this.measurementName = '';
      this.unit = '';
      this.valueHtml = '<p></p>'; // Reset valueHtml
      this.editingMeasurement = null;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },

    editMeasurement(item) {
      this.dialogTitle = 'EDIT MEASUREMENTS';
      this.dialogButtonText = 'UPDATE';
      this.measurementName = item.name;
      this.unit = item.unit;
      this.valueHtml = item.description; // Update valueHtml with description
      this.editingMeasurement = item;
      this.dialog = true;
    },

    async deleteItems() {
      try {
        const token = localStorage.getItem("token");
        const ItemID = this.selectedProductId;

        const response = await axios.post(
            `/api/delete/measurements/${ItemID}`,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
        );

        if (response.status === 200) {
          this.showSnackbar('Measurement Deleted.', 'success');
          this.delete_measurement_dialog = false;
          this.measurementUnits = this.measurementUnits.filter(m => m.id !== this.selectedProductId);
        } else {
          // alert("Failed to delete measurements.");
          this.showSnackbar('Failed to delete measurements.', 'error');

        }
      } catch (error) {
        console.error("Error updating measurement:", error);
        // alert("Failed to update measurement.sda");
        this.showSnackbar('Failed to delete measurements.', 'error');

      }
    },
    async exportPDF() {
      const doc = new jsPDF();

      // Load images (ensure Base64 format or accessible publicly)
      const logo1 = require('@/img/company_logo/logo_full_5.png'); // Adjust the path as needed
      const logo2 = require('@/img/company_logo/logo_full_5.png'); // Adjust the path as needed

      // Add logos on the same line, with smaller size
      doc.addImage(logo1, 'PNG', 14, 10, 20, 10);
      doc.addImage(logo2, 'PNG', 40, 10, 20, 10);

      // Title with gray color and gray border
      doc.setFontSize(9);
      doc.setFont("helvetica");
      doc.setTextColor(128, 128, 128); // Gray color for text
      doc.text("COMPREHENSIVE ANALYSIS OF ALL PRODUCTS MEASUREMENTS DETAILS.", 20, 40);
      doc.setDrawColor(192, 192, 192); // Gray border
      doc.rect(14, 30, doc.internal.pageSize.width - 28, 20, 'S');

      // Box for totalMeasurements with blue outline and background
      doc.setFillColor(0, 102, 204); // Blue background
      doc.setDrawColor(0, 102, 204); // Blue outline
      doc.rect(doc.internal.pageSize.width - 65, 33, 15, 15, 'FD'); // Fill and stroke
      doc.setTextColor(255, 255, 255); // White text inside blue box
      doc.setFontSize(12);
      doc.text(this.totalMeasurements, doc.internal.pageSize.width - 60, 41.5);

      // "UNITS COUNT" label with black outline
      doc.setFillColor(255, 255, 255); // White background
      doc.setDrawColor(0, 0, 0); // Black outline
      doc.rect(doc.internal.pageSize.width - 43, 33, 25, 15, 'S');
      doc.setTextColor(0, 0, 0); // Black text
      doc.setFontSize(7);
      doc.text("UNITS COUNT", doc.internal.pageSize.width - 38, 41.5);

      // Title below card
      doc.setFontSize(12);
      doc.setTextColor(0);
      doc.text("PRODUCTS MEASUREMENTS DATASET", 14, 65);

      // Prepare table data
      const tableData = this.measurementUnits.map((item, index) => ({
        index: index + 1,
        name: item.name,
        unit: item.unit,
        description: this.stripHtmlTags(item.description),
      }));

      // Define table columns
      const tableColumns = [
        {header: 'Measurement Name', dataKey: 'name'},
        {header: 'Unit', dataKey: 'unit'},
        {header: 'Description', dataKey: 'description'},
      ];

      // Generate table with alternating row colors
      doc.autoTable({
        head: [tableColumns.map(col => col.header)],
        body: tableData.map(row => [row.name, row.unit, row.description]),
        startY: 70,
        headStyles: {fillColor: [245, 245, 245], textColor: [0, 0, 0], fontSize: 10},
        bodyStyles: {fontSize: 9},
        alternateRowStyles: {fillColor: [240, 240, 240]}, // Alternating row color
        columnStyles: {
          0: {cellWidth: 50},
          1: {cellWidth: 20},
          2: {cellWidth: 110},
        },
        styles: {cellPadding: 4, overflow: 'linebreak'},
        theme: 'grid',
        didDrawPage: function (data) {
          // Get the total number of pages
          const totalPages = doc.internal.getNumberOfPages();
          // Display the current page number and total pages
          doc.setFontSize(8);
          doc.text(`Page ${data.pageNumber} of ${totalPages}`, doc.internal.pageSize.width - 30, 10);
        },
      });

      // Save the PDF
      doc.save('Measurement_Units_Report.pdf');

      const fileName = 'Measurement_Units_Report.pdf';
      const file_type = 'pdf';
      this.logDocumentDownload(fileName, file_type);
    },

    async logDocumentDownload(fileName, file_type) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        // Asynchronous API call to log download
        const response = await axios.post(`/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: 'Product Management',

          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    exportExcel() {
      console.log("Exporting to Excel");

      // Prepare worksheet data
      const worksheetData = [
        ['Measurement Name', 'Unit', 'Description'], // Headers
        ...this.measurementUnits.map(item => [
          item.name,
          item.unit,
          this.stripHtmlTags(item.description),
        ])
      ];

      // Create worksheet and apply formatting
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Apply header styling
      const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({r: 0, c: C});
        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          font: {bold: true, color: {rgb: "FFFFFF"}},
          fill: {fgColor: {rgb: "0070C0"}}, // Blue background
          alignment: {horizontal: 'center', vertical: 'center'},
          border: {
            top: {style: "thin", color: {rgb: "000000"}},
            bottom: {style: "thin", color: {rgb: "000000"}},
            left: {style: "thin", color: {rgb: "000000"}},
            right: {style: "thin", color: {rgb: "000000"}}
          }
        };
      }

      // Apply body alignment and alternating row colors
      for (let R = 1; R <= headerRange.e.r; ++R) {
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({r: R, c: C});
          if (!worksheet[cellAddress]) continue;

          worksheet[cellAddress].s = {
            alignment: {horizontal: 'left', vertical: 'center'},
            fill: {fgColor: {rgb: R % 2 === 0 ? "F0F0F0" : "FFFFFF"}}, // Alternating row color
            border: {
              top: {style: "thin", color: {rgb: "000000"}},
              bottom: {style: "thin", color: {rgb: "000000"}},
              left: {style: "thin", color: {rgb: "000000"}},
              right: {style: "thin", color: {rgb: "000000"}}
            }
          };
        }
      }

      // Set column widths for better alignment
      worksheet['!cols'] = [
        {wch: 30}, // Measurement Name
        {wch: 15}, // Unit
        {wch: 50}  // Description
      ];

      // Create workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Measurements');

      // Export the workbook to Excel file
      XLSX.writeFile(workbook, 'Measurement_Units_Report.xlsx');

      const fileName = 'Measurement_Units_Report.xlsx';
      const file_type = 'excel';
      this.logDocumentDownload(fileName, file_type);
    },
    changePage(newPage) {
      this.page = newPage;
    },
    addProductsPageRoute() {
      console.log("Navigating to bulk upload");
    },
    backPageRoute() {
      console.log("Going back");
    }
  },
  mounted() {
    const dashboardId = 2;
    this.permissions = getPermissions(dashboardId);
    this.fetchMeasurements();
  }
}
</script>

<style scoped>

</style>